// extracted by mini-css-extract-plugin
module.exports = {"cls1":"UserWorklistsPage-CssProp1_th-module--cls1--8FXMc","cls2":"UserWorklistsPage-CssProp1_th-module--cls2--1R3qA UserWorklistsPage-CssProp1_th-module--cls1--8FXMc"};